export const ADD_EDIT_TOURNEE_MODELE = {
  title: {
    add: 'Ajouter une liste d\'affichage',
    edit: 'Modifier la liste d\'affichage: {nom}',
    breadcrumbEdit: 'Modifier la liste d\'affichage',
  },
  actions: {
    cancel: 'Annuler',
    delete: 'Supprimer',
  },
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste d\'affichage',
  },
  errors: {
    problemOccurred: 'Un problème est survenu',
    noActionSelect: 'Aucune action sélectionnée',
    libelle: 'Nom de la liste d\'affichage',
    jourDepart: 'Jour de départ',
    ordre: 'Ordre',
    afficheur: 'Afficheur',
    forbiddenUpdateWithfaces: 'Impossible de modifier une liste d\'affichage archivée pour y ajouter des faces',
  },
  success: {
    add: 'La liste d\'affichage a été ajoutée avec succès.',
    edit: 'La liste d\'affichage a été modifiée avec succès.',
  },
  info: {
    facesAlreadyInList: 'La face est déjà affectée sur la liste "{listeAffichage}"',
    facesFromPatrimoine: 'Toutes les faces de ce patrimoine n\'ont pas pu être affecté',
    facesAddSuccessMulti: 'Les faces ont été ajoutées',
    facesAddSuccess: 'La face a été ajoutée',
    patrimoineAddSuccess: 'Le patrimoine a été ajouté',
    patrimoineAddSuccessMulti: 'Les patrimoines ont été ajouté',
  },
  facesNotAddListeAffichage: {
    titleMulti: '{nbreFaces} faces n\'ont pas pu être ajoutées dans la liste',
    titleSingle: '1 face n\'a pas pu être ajoutée dans la liste',
    faceSurListeAffichage: 'La face est sur la liste d\'affichage {liste}.',
    faceNonPatrimoine: 'Le produit face du réseau ne fait pas partie du patrimoine',
    tab: {
      codeFace: 'Face',
      motif: 'Motif',
    },
  },
  autocomplete: {
    search: 'Recherche...',
    noRslt: 'Aucun résultat',
  },
  informations: {
    title: 'Information de la liste d\'affichage',
    nom: 'Nom de la liste d\'affichage',
    jourDepart: 'Jour de départ',
    afficheur: 'Afficheur affecté',
  },
  ajoutFace: {
    title: 'Ajouter des faces à votre liste',
    breadcrumb: {
      home: 'Accueil',
      liste: 'Liste d\'affichage',
      add: 'Ajouter une liste d\'affichage',
      edit: 'Modifier une liste d\'affichage',
      addFace: 'Ajouter une face',
    },
  },
  associesFaceReseau: {
    title: 'Faces et réseaux associés',
    placeholderAutocomplete: 'Ajouter un emplacement / dispositif / matériel / face / réseau',
    addFace: 'Ajouter des faces',
    dateReference: 'Visu',
    faceUnitaire: 'Faces unitaires',
    reseauLc: 'Réseaux Lc',
    reseauTempo: 'Réseaux tempo',
    isDraggable: 'Trier par "glisser déposer"',
    emplacements: 'Emplacements',
    dispositifs: 'Dispositifs',
    materiels: 'Matériels',
    table: {
      dispositif: 'Dispositif',
      materiel: 'Matériel',
      face: 'Face',
      etat: 'Etat',
      format: 'Format',
      adresse: 'Adresse',
      CP: 'CP',
      ville: 'Ville',
      reseau: 'Réseau',
      commercialisable: 'Commercialisable',
      disposition: 'Disposition',
      ordre: 'Ordre',
    },
  },
};

export const LISTE_TOURNEE_MODELE = {
  title: 'Liste d’affichages',
  newListe: 'Nouvelle liste d’affichage',
  search: 'Rechercher',
  tableau: {
    nomListeAffichage: 'Nom de la liste d’affichage',
    afficheurAffecte: 'Afficheur affecté',
    joursDepart: 'Jour de départ',
    nbFaces: 'Nb de faces',
    agence: 'Agence',
    actions: {
      edit: 'Modifier',
      delete: 'Supprimer',
    },
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    agence: 'Agence',
    afficheur: 'Afficheur(s)',
    actif: 'Actif',
    appliquer: 'Appliquer',
    reinitialiser: 'Réinitialiser',
  },
  breadcrumb: {
    racine: 'Accueil',
    listeAffichage: 'Liste d’affichages',
  },
  archivageDesarchiver: {
    archivage: 'Etes-vous sûr de vouloir archiver cette liste d\'affichage ?',
    desarchivage: 'Etes-vous sûr de vouloir désarchiver cette liste d\'affichage ?',
  },
  messages: {
    success: {
      archivage: 'Liste d\'affichage archivée avec succès.',
      desarchivage: 'Liste d\'affichage désarchivée avec succès.',
      deleteTournee: 'La liste d\'affichage supprimée avec succès',
    },
    error: {
      listeAffichageWithoutFace: 'La liste d\'affichage ne doit pas contenir de faces',
    },
  },
  popUpSuppression: {
    title: 'Etes-vous sûr de vouloir supprimer cette liste d\'affichage ?',
  },
};

export const DETAIL_TOURNEE_MODELE = {
  title: 'Détail : {nomTournee}',
  newListe: 'Nouvelle liste d’affichage',
  search: 'Rechercher',
  actions: {
    edit: 'Modifier',
    delete: 'Supprimer',
  },
  tableau: {
    order: 'Ordre',
    dispositif: 'Dispositif',
    materiel: 'Matériel',
    face: 'Face',
    format: 'Format',
    address: 'Adresse',
    cp: 'CP',
    ville: 'Ville',
    reseau: 'Reseau',
    commercialisable: 'Commercialisable',
    etat: 'Etat',
    disposition: 'Disposition',
    actions: {
      edit: 'Modifier',
      delete: 'Supprimer',
    },
  },
  breadcrumb: {
    racine: 'Accueil',
    listeAffichage: 'Liste d’affichages',
    detailTourneeAffichage: 'Détail de la liste d\'affichage',
  },
  informationPrincipal: {
    title: 'Information de la liste d\'affichage',
    nom: 'Nom de la liste :',
    jourDepart: 'Jour de départ :',
    nbFaces: 'Nb de faces :',
    afficheurAffecte: 'Afficheur affecté :',
    agence: 'Agence :',
  },
  archivageDesarchiver: {
    archivage: 'Etes-vous sûr de vouloir archiver cette liste d\'affichage ?',
    desarchivage: 'Etes-vous sûr de vouloir désarchiver cette liste d\'affichage ?',
  },
  messages: {
    success: {
      archivage: 'Liste d\'affichage archivée avec succès.',
      desarchivage: 'Liste d\'affichage désarchivée avec succès.',
      deleteTournee: 'La liste d\'affichage supprimée avec succès',
    },
    error: {
      listeAffichageWithoutFace: 'La liste d\'affichage ne doit pas contenir de faces',
      forbiddenDeleteWithTfs: 'Impossible de supprimer une liste d\'affichage a lequel est liée des affectations logistiques',
    },
  },
  popUpSuppression: {
    title: 'Etes-vous sûr de vouloir supprimer cette liste d\'affichage ?',
  },
  archive: 'Archivé',
};
